import defaultTheme from './defaultTheme';
const gapTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#000e3e', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#000e3e', background: '#000e3e' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#000e3e' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#000e3e', border: '#000e3e', background: '#000e3e' }), field: {
        focus: '#000e3e',
        label: '#000e3e',
        icon: '#000e3e',
    } });
export default gapTheme;
